import { render } from "./AddForumModal.vue?vue&type=template&id=b1e035a8&ts=true"
import script from "./AddForumModal.vue?vue&type=script&lang=ts"
export * from "./AddForumModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__